import { Directive } from '@angular/core';

import { FormValue } from '../form-controls/entities/form-value.entity';
import { BaseControlValueAccessor } from './base-control-value-accessor';

@Directive()
export abstract class MultiValueFormInput<T> extends BaseControlValueAccessor {
    writeValue(obj: any): void {
        if (obj === null) {
            this.writeValueImpl([]);
            return;
        }

        if (!(obj instanceof Array && obj.every(v => v instanceof FormValue))) {
            console.error('MultiValueFormInput:: value must be Array<FormValue<any>>', obj);
            this.writeValueImpl([]);
            return;
        }
        this.writeValueImpl(obj);
    }

    propagateChange(_: FormValue<T>[]): void {
        super.propagateChange(_);
    }

    propagateSimpleChange(_: T[]): void {
        super.propagateChange(_);
    }

    protected abstract writeValueImpl(obj: FormValue<any>[]): void;
}
